import { render, staticRenderFns } from "./PortalStatistics.vue?vue&type=template&id=d062496c"
import script from "./PortalStatistics.vue?vue&type=script&lang=js"
export * from "./PortalStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports